module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.active) ? _c('video', {
    attrs: {
      "id": "player",
      "src": _vm.movie.videoUrl,
      "autoplay": "",
      "controls": ""
    }
  }) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0c0a64b0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Player.vue
// module id = 78
// module chunks = 0